export enum NotificationTypeEnum {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info'
}
